import styled from 'styled-components';
import checkIcon from '../../img/checkWhite.png';

const BoxSize = styled.div`
	&.form-step-1 {
		min-height: 10vh !important;

		@media (min-width: 993px) {
			max-width: 490px;
			margin: auto;
		}
	}

	.form-step-5 {
		@media (min-width: 993px) {
			max-width: 490px;
			margin: auto;
		}
	}

	.virtualCard {
	margin-bottom: 25px;
	}

	.inputHeight {
		height: 76px;
	}

	.form-size {
		display: flex;
		flex-flow: row wrap;
		justify-content: space-between;

		.form-size-1 {
			width: 48%;
		}
		.form-size-2 {
			width: 48%;
		}
		.form-size-3 {
			width: 100%;
		}
	}
	.notification-checkbox {
		display: flex;
		align-items: center;

		input {
			all: unset;
			border: 1px solid black;
			border-radius: 2px;
			min-width: 14px;
			max-width: 14px;
			height: 14px;
			display: inline-block;
			cursor: pointer;
			opacity: 0.6;
		}

		input:hover {
			opacity: 1;
		}

		input:checked {
			border: 1px solid ${({ theme }) => theme.colorBorderBtn};
			opacity: 1;
			background: ${({ theme }) => theme.colorBackgroundChecked}
				url(${checkIcon}) no-repeat center;
			background-size: contain;
			min-width: 14px;
			max-width: 14px;
			height: 14px;
		}
		input:checked:hover {
			border-color: ${({ theme }) => theme.colorBorderBtnHover};
			background: ${({ theme }) => theme.colorBorderBtnHover} url(${checkIcon})
				no-repeat center;
			background-size: contain;
		}
		h5 {
			margin-left: 6px;
		}
	}

	@media (max-width: 992px) {
		width: 90%;
		margin: auto;
		.form-size {
			.form-size-1 {
				width: 100%;
			}

			.form-size-2 {
				width: 48%;
			}

			.form-size-3 {
				width: 48%;
			}
		}
	}

	.content-align {
		text-align: center;
		h2 {
			color: #1a62f4;
			font-weight: 500 !important;
		}
		h3 {
			color: #1a62f4;
		}
	}

	.loading-beneficiario2 {
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: center;
		width: 270px;
		color: gray;
		border-radius: 15px;
		border: none;
		background-color: #ddd;
		font-size: 15px;
		padding: 10px 25px;
		margin: 10px auto;
		font-weight: 800;
		svg {
			//margin: 0 10px 0 0 !important;
		}
		span {
			margin: 0 0 0 10px;
			padding: 0;
		}
	}

	@media (max-width: 992px) {
		.box-content-width {
			.isDisabled {
				width: 270px !important;
			}
			.btn-forward {
				width: 270px !important;
			}
			.loading-beneficiario2 {
				width: 270px !important;
			}
		}
		&.box-content-width-success2 {
			.btn-forward {
				width: 270px !important;
			}
		}
	}

	.content-vivo {
		text-align: center;

		h2 {
			margin: 20px 0 15px 0 !important;
		}
	}

	.box-content-width {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		img {
			//height: 400px;
			margin-top: 30px;
			margin-bottom: 10px;
		}
		a {
			margin-bottom: 15px;
		}
	}
	.title-alert2 {
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: left;
		border-bottom: 1px solid ${({ theme }) => theme.colorBorderBtn};
		align-items: baseline;
	}
	.icon-container2 {
		text-align: left;
		background: #0079b3;
		padding: 7px 2px 7px 7px;
		border-radius: 50%;
		display: flex;
		align-items: center;
		margin-left: 0;
		margin-right: 10px;
		svg {
			margin-left: auto;
			margin-right: auto;
		}
	}

	@media (min-height: 800px) {
		.footer-adjustment {
			height: calc(100vh - 230px);
		}
	}

	.box-number {
		display: flex;
		flex-direction: column;
		span {
			font-size: 12px;
		}
	}

	.box-tel {
		display: flex;
		flex-direction: row;
		align-items: baseline;
		justify-content: space-between;
		h3 {
			font-size: 20px;
			margin: 0;
			color: #323232de;
		}
		a {
			font-size: 12px;
		}
	}

	&.box-content-success {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: space-between;
		img {
			margin-top: 40px;
			margin-bottom: 10px;
			max-width: 100%;
			width: 300px;
			height: 190px;
		}
		button {
			margin-bottom: 20px !important;
		}
		h3 {
			margin-bottom: 25px;
		}
	}

	.box-content-group {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		img {
			//height: 400px;
			margin-top: 30px;
			margin-bottom: 10px;
		}
		a {
			margin-bottom: 15px;
		}
	}

	.content-cmd {
		text-align: center;
		h2 {
			color: #0446c9;
			font-weight: 500 !important;
		}
		h3 {
			color: #0446c9;
		}
	}

	&.box-content-width-success2 {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: space-between;
		img {
			//margin-top: 40px;
			max-width: 100%;
			width: 300px;
			//height: 190px;
		}
		button {
			margin-bottom: 20px !important;
		}
		h3 {
			margin-bottom: 10px;
		}
	}
`;

export default BoxSize;
